import { useState } from "react";

import { isTokenExpired } from "../../utils";

const useToken = () => {
  const [token, setToken] = useState(localStorage.getItem("admin-token") || "");

  const updateToken = (newToken) => {
    setToken(newToken);
    localStorage.setItem("admin-token", newToken);
  };

  const clearToken = () => {
    setToken("");
    localStorage.removeItem("admin-token");
  };

  const ensureValidToken = async (onExpired) => {
    if (!token || isTokenExpired(token)) {
      if (onExpired) onExpired();

      return null;
    }

    return token;
  };

  return { token, updateToken, clearToken, ensureValidToken };
};

export default useToken;
